// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b9ee717","239":"acfec82f","455":"7eacf540"}[chunkId] + ".chunk.js";
};